const contentRegex = /LODOP.ADD_PRINT_\S+A\("(\S+)",\d+,\d+,\d+,\d+,.+\)/g

/**
 * 将模板数值转为 number（后端 BigDecimal / JSON 可能为字符串，避免 + 发生字符串拼接）
 * @param {*} value
 * @param {number} [fallback=0]
 * @returns {number}
 */
function toMmNum (value, fallback = 0) {
    const num = Number(value)
    return Number.isFinite(num) ? num : fallback
}

/**
 * 格式化为 LODOP 毫米单位字符串
 * @param {*} value
 * @returns {string}
 */
function toMmUnit (value) {
    return toMmNum(value) + 'mm'
}

// 复用 Lodop 封装实例，避免每次 new Lodop() 重复注入 CLodopfuncs.js 导致第二次 getLodop 失败
let lodopHelper = null
let lodopTaskQueue = Promise.resolve()

/**
 * 获取 Lodop 封装单例（仅初始化 CLodop 脚本一次）
 * @returns {Object|null}
 */
function getLodopHelper () {
    if (!lodopHelper && window.etao && window.etao.lodop) {
        lodopHelper = window.etao.lodop()
    }
    return lodopHelper
}

/**
 * 获取 LODOP 控件对象
 * @returns {Object|null}
 */
function getActiveLODOP () {
    const helper = getLodopHelper()
    if (!helper) {
        return null
    }
    return helper.getLodop()
}

/**
 * 获取 CLodop 全局对象（由 CLodopfuncs.js 注入）
 * @returns {Object|undefined}
 */
function getClodop () {
    return window.CLODOP
}

/**
 * 清除 CLodop 异步回调，避免上一次打印回调干扰下一次
 */
function clearClodopReturn () {
    const clodop = getClodop()
    if (clodop) {
        clodop.On_Return = null
    }
}

/**
 * 设置 CLodop 异步回调
 * @param {Function|null} handler
 */
function setClodopReturn (handler) {
    const clodop = getClodop()
    if (clodop) {
        clodop.On_Return = handler
    }
}

/** CLodop 单批打印等待 On_Return 的超时（毫秒） */
const CLODOP_RETURN_TIMEOUT_MS = 30000

/**
 * 串行执行 LODOP 任务，避免 CLodop 异步打印未完成时再次调用失败
 * @param {Function} taskFn 接收 done 回调
 * @returns {Promise<void>}
 */
function runLodopTask (taskFn) {
    lodopTaskQueue = lodopTaskQueue.then(() => new Promise((resolve) => {
        let settled = false
        const done = () => {
            if (settled) {
                return
            }
            settled = true
            resolve()
        }
        try {
            taskFn(done)
        } catch (e) {
            console.error('[lodopPrint]', e)
            done()
        }
    }))
    return lodopTaskQueue
}

/**
 * 判断 CLodop On_Return 返回值是否表示失败
 * @param {*} value
 * @returns {boolean}
 */
function isClodopReturnFailed (value) {
    return value === false || value === 0 || value === '0' || value === 'false'
}

/**
 * 包装 CLodop 异步操作：防重复回调、超时兜底、异常时释放打印队列
 * @param {Object} LODOP
 * @param {Function} clodopAction 如 () => LODOP.PRINT()
 * @param {Function} onFinished (success: boolean) => void
 */
function runClodopAsyncAction (LODOP, clodopAction, onFinished) {
    let settled = false
    let timer = null

    const finish = (success) => {
        if (settled) {
            return
        }
        settled = true
        if (timer != null) {
            clearTimeout(timer)
            timer = null
        }
        clearClodopReturn()
        onFinished(success)
    }

    if (!LODOP || !LODOP.CVERSION) {
        try {
            clodopAction()
            finish(true)
        } catch (e) {
            console.error('[lodopPrint]', e)
            finish(false)
        }
        return
    }

    timer = setTimeout(() => {
        console.warn('[lodopPrint] CLodop On_Return timeout')
        finish(false)
    }, CLODOP_RETURN_TIMEOUT_MS)

    setClodopReturn(function (TaskID, Value) {
        finish(!isClodopReturnFailed(Value))
    })

    try {
        clodopAction()
    } catch (e) {
        console.error('[lodopPrint]', e)
        finish(false)
    }
}

/**
 * 应用本地保存的打印机配置
 * @param {Object} LODOP
 */
function applyPrinterSettings (LODOP) {
    const printer = localStorage.getItem('emis-label-printer-lodop')
    if (printer) {
        LODOP.SET_PRINTER_INDEX(printer)
    }
}

/**
 * 设置 LODOP 通用打印模式
 * @param {Object} LODOP
 */
function applyCommonPrintModes (LODOP) {
    LODOP.SET_PRINT_MODE('PRINT_SETUP_PROGRAM', false)
    LODOP.SET_PRINT_MODE('POS_BASEON_PAPER', true)
    LODOP.SET_PRINT_MODE('PRINT_NOCOLLATE', true)
    LODOP.SET_PRINT_MODE('PRINT_MODE', 'FULL')
}
export function parseTemplateContent (templateContent) {
    let codeList = []
    if (!templateContent) {
        return
    }
    let content = templateContent.split(';')
    for (let contentElement of content) {
        let match = contentRegex.exec(contentElement)
        console.log(contentRegex.exec(contentElement))
        if (match) {
            codeList.push(match[1])
        }
    }
    return codeList
}

export function getPrinterList () {
    const LODOP = getActiveLODOP()
    if (!LODOP) {
        return
    }
    let count = LODOP.GET_PRINTER_COUNT()
    let list = []
    for (let i = 0; i < count; i++) {
        let printer = LODOP.GET_PRINTER_NAME(i)
        if (printer) {
            list.push(printer)
        }
    }
    return list
}

export function print (templateContent, printDate) {
    runLodopTask((done) => {
        const LODOP = getActiveLODOP()
        if (!LODOP) {
            done()
            return
        }
        applyPrinterSettings(LODOP)
        let codeList = []
        if (!templateContent) {
            done()
            return
        }
        // eslint-disable-next-line no-eval
        eval(templateContent)
        let content = templateContent.split(';')
        for (let contentElement of content) {
            let match = contentRegex.exec(contentElement)
            console.log(contentRegex.exec(contentElement))
            if (match) {
                codeList.push(match[1])
            }
        }
        printLegacyPages(LODOP, codeList, printDate, 0, done)
    })
}

/**
 * 逐页执行旧版 eval 模板打印（CLodop 下串行）
 */
function printLegacyPages (LODOP, codeList, printDate, index, done) {
    if (index >= printDate.length) {
        done()
        return
    }
    const date = printDate[index]
    for (let field of codeList) {
        LODOP.SET_PRINT_STYLEA(field, 'Content', date[field])
    }
    runClodopAsyncAction(LODOP, () => LODOP.PRINT(), (success) => {
        if (!success) {
            window.etao.message.toast('标签打印失败，请检查打印机或模板配置', 'error')
            done()
            return
        }
        setTimeout(() => {
            printLegacyPages(LODOP, codeList, printDate, index + 1, done)
        }, 0)
    })
}

export function lodopPrint (materialSnPrintLabelInfo, printer) {
    console.log('data = ' + JSON.stringify(materialSnPrintLabelInfo))
    console.log('printer' + printer)
    const elements = JSON.parse(materialSnPrintLabelInfo.content || '[]')
    let labelSetting =
        {
            labelWidth: materialSnPrintLabelInfo.width,
            labelHeight: materialSnPrintLabelInfo.height
        }

    printReal(elements, labelSetting, materialSnPrintLabelInfo.generalData)
}

export const ACTIONS = {
    PREVIEW: 'preview', PRINT: 'print', TEST_PRINT: 'print_test'
}

/**
 *  预览
 * @param elements
 * @param labelSetting
 */
export function preview (elements = [], labelSetting) {
    runLodopTask((done) => {
        initLodopPrint(ACTIONS.PREVIEW, elements, labelSetting.labelWidth, labelSetting.labelHeight, [], done)
    })
}

/**
 * 打印测试
 * @param elements
 * @param labelSetting
 * @param printDataList
 */
export function printTest (elements = [], labelSetting, printDataList) {
    runLodopTask((done) => {
        initLodopPrint(ACTIONS.TEST_PRINT, elements, labelSetting.labelWidth, labelSetting.labelHeight, [{}], done)
    })
}

/**
 * 实际打印
 * @param elements
 * @param labelSetting
 * @param printDataList
 */
export function printReal (elements = [], labelSetting, printDataList) {
    // 数据不存在则报错
    if (!printDataList || printDataList.length <= 0) {
        window.etao.message.toast('打印数据未传入', 'error')
        return
    }
    if (!elements || elements.length <= 0) {
        window.etao.message.toast('打印模板未设置任何元素，不能打印', 'error')
        return
    }
    runLodopTask((done) => {
        initLodopPrint(ACTIONS.PRINT, elements, labelSetting.labelWidth, labelSetting.labelHeight, printDataList, done)
    })
}

// 修改打印预览方法
export function initLodopPrint (action = ACTIONS.PREVIEW, elements = [], labelWidth, labelHeight, printDataList = [], onComplete) {
    const LODOP = getActiveLODOP()
    if (!LODOP) {
        window.etao.message.toast('未找到 LODOP 对象，请检查是否正确安装打印插件', 'error')
        if (onComplete) {
            onComplete()
        }
        return null
    }
    applyPrinterSettings(LODOP)
    clearClodopReturn()

    const finish = () => {
        clearClodopReturn()
        if (onComplete) {
            onComplete()
        }
    }

    if (ACTIONS.PREVIEW === action) {
        LODOP.PRINT_INIT('标签预览')
        applyCommonPrintModes(LODOP)
        LODOP.SET_PRINT_PAGESIZE(1, toMmUnit(labelWidth), toMmUnit(labelHeight), '')
        printOnePage(action, LODOP, elements)
        runClodopAsyncAction(LODOP, () => LODOP.PREVIEW(), () => finish())
        return LODOP
    }

    // 打印时防止数据过多导致打印效率慢，将 printDataList 拆分成为50个对象一份
    let printDataListList = printDataList.reduce((acc, cur, index) => {
        if (index % 50 === 0) {
            acc.push([])
        }
        acc[acc.length - 1].push(cur)
        return acc
    }, [])

    executePrintBatches(LODOP, action, elements, labelWidth, labelHeight, printDataListList, 0, finish)
    return LODOP
}

/**
 * 分批串行提交 CLodop 打印任务
 */
function executePrintBatches (LODOP, action, elements, labelWidth, labelHeight, printDataListList, batchIndex, onComplete) {
    if (batchIndex >= printDataListList.length) {
        onComplete()
        return
    }

    try {
        LODOP.PRINT_INIT('标签打印')
        applyCommonPrintModes(LODOP)
        LODOP.SET_PRINT_PAGESIZE(1, toMmUnit(labelWidth), toMmUnit(labelHeight), '')
        for (let printData of printDataListList[batchIndex]) {
            printOnePage(action, LODOP, elements, printData)
        }
        LODOP.SET_PRINT_MODE('CUSTOM_TASK_NAME', '标签打印' + batchIndex)

        runClodopAsyncAction(LODOP, () => LODOP.PRINT(), (success) => {
            if (!success) {
                window.etao.message.toast('标签打印失败，请检查打印机或模板配置', 'error')
                onComplete()
                return
            }
            // 异步推进下一批，避免 CLodop 报错时 On_Return 同步递归导致栈溢出/死循环
            setTimeout(() => {
                executePrintBatches(LODOP, action, elements, labelWidth, labelHeight, printDataListList, batchIndex + 1, onComplete)
            }, 0)
        })
    } catch (e) {
        console.error('[lodopPrint]', e)
        window.etao.message.toast('标签打印失败，请检查模板尺寸配置', 'error')
        onComplete()
    }
}

function printOnePage (action, LODOP, elements = [], printData) {
    // 分离SVG元素和非SVG元素
    const svgElements = []
    const nonSvgElements = []

    elements.forEach(element => {
        if (isSvgElement(element)) {
            svgElements.push(element)
        } else {
            nonSvgElements.push(element)
        }
    })

    LODOP.NewPage()
    // 先添加非SVG元素（使用原生打印）
    nonSvgElements.forEach(element => {
        switch (element.type) {
            case 'text':
                addTextElement(action, LODOP, element, printData)
                break
            case 'barcode':
                addBarcodeElement(action, LODOP, element, printData)
                break
            case 'line':
                addLineElement(LODOP, element)
                break
            case 'rect':
                addRectElement(LODOP, element)
                break
            case 'oval':
                addOvalElement(LODOP, element)
                break
            case 'image':
                addImageElement(LODOP, element)
                break
            case 'table':
                addTableElement(action, LODOP, element, printData)
                break
        }
    })
    // 如果有SVG元素，使用HTML模式添加
    svgElements.forEach(element => {
        addSvgElements(LODOP, element)
    })
}

// 判断元素是否包含SVG
function isSvgElement (element) {
    // 检查元素是否包含SVG内容
    // 这里需要根据实际情况添加判断逻辑
    return element.type === 'image' && element.imageUrl && element.imageUrl.toLowerCase().startsWith('data:image/svg+xml')
}

// 添加SVG元素（使用HTML模式）
function addSvgElements (LODOP, element) {
    let labelWidth = toMmNum(element.width)
    let labelHeight = toMmNum(element.height)
    // 创建一个临时容器来存放SVG元素
    const container = document.createElement('div')
    container.style.position = 'relative'
    container.style.width = mmToPx(labelWidth) + 'px'
    container.style.height = mmToPx(labelHeight) + 'px'

    // 添加每个SVG元素
    const elementDiv = document.createElement('div')
    elementDiv.style.position = 'absolute'
    // elementDiv.style.left = mmToPx(element.x) + 'px'
    // elementDiv.style.top = mmToPx(element.y) + 'px'
    elementDiv.style.width = mmToPx(element.width) + 'px'
    elementDiv.style.height = mmToPx(element.height) + 'px'

    // 如果是SVG URL
    elementDiv.innerHTML = `<img src="${element.imageUrl}" style="width:100%;height:100%;">`

    // 应用旋转
    if (element.rotate) {
        elementDiv.style.transform = `rotate(${element.rotate}deg)`
    }

    container.appendChild(elementDiv)

    // 使用超文本模式添加SVG元素
    LODOP.ADD_PRINT_HTM(toMmUnit(element.y), toMmUnit(element.x), toMmUnit(labelWidth), toMmUnit(labelHeight), container.outerHTML)
}

// 添加文本元素
function addTextElement (action, LODOP, element, printData = {}) {
    const content = resolveTextContent(action, element, printData)

    // 添加文本到打印页面
    LODOP.ADD_PRINT_TEXT(toMmUnit(element.y), toMmUnit(element.x), toMmUnit(element.width), toMmUnit(element.height), content)

    // 基础文本样式
    LODOP.SET_PRINT_STYLEA(0, 'FontName', element.fontFamily || 'Microsoft YaHei')
    LODOP.SET_PRINT_STYLEA(0, 'FontSize', element.fontSize || 12)

    // 字体粗细
    LODOP.SET_PRINT_STYLEA(0, 'Bold', element.fontWeight === 'bold' ? 1 : 0)

    // 对齐方式
    LODOP.SET_PRINT_STYLEA(0, 'Alignment', element.align === 'center' ? 2 : element.align === 'right' ? 3 : 1)

    // 文本颜色
    if (element.color) {
        LODOP.SET_PRINT_STYLEA(0, 'FontColor', element.color)
    }

    // 背景颜色
    if (element.backgroundColor) {
        LODOP.SET_PRINT_STYLEA(0, 'BackgroundColor', element.backgroundColor)
    }

    // 下划线
    if (element.underline === '1') {
        LODOP.SET_PRINT_STYLEA(0, 'Underline', 1)
    }

    // 斜体
    if (element.italic === '1') {
        LODOP.SET_PRINT_STYLEA(0, 'Italic', 1)
    }

    // 行高
    if (element.lineHeight) {
        // LODOP.SET_PRINT_STYLEA(0, 'LineSpacing', Math.round((element.lineHeight - 1) * 100))
    }

    // 字间距
    if (element.letterSpacing) {
        LODOP.SET_PRINT_STYLEA(0, 'LetterSpacing', element.letterSpacing)
    }

    // 文本换行：单元格内必须在控件区域内换行，防止溢出到下方单元格
    if (element.isCellContent) {
        LODOP.SET_PRINT_STYLEA(0, 'WordWrap', element.wordWrap === 'nowrap' ? 0 : 1)
    } else if (element.wordWrap === 'nowrap') {
        LODOP.SET_PRINT_STYLEA(0, 'WordWrap', 0)
    } else if (element.wordWrap === 'break-word') {
        LODOP.SET_PRINT_STYLEA(0, 'WordWrap', 1)
    }

    // 旋转角度
    if (element.rotate) {
        LODOP.SET_PRINT_STYLEA(0, 'Angle', 360 - parseInt(element.rotate))
    }

    // 边框设置
    if (element.borderLeft === 'true' || element.borderTop === 'true' || element.borderRight === 'true' || element.borderBottom === 'true') {
        let frameType = 0
        if (element.borderLeft === 'true') frameType |= 9 // Left
        if (element.borderTop === 'true') frameType |= 7 // Upper
        if (element.borderRight === 'true') frameType |= 10 // Right
        if (element.borderBottom === 'true') frameType |= 8 // Under

        LODOP.SET_PRINT_STYLEA(0, 'TextFrame', frameType)

        // 设置边框颜色
        if (element.borderColor) {
            LODOP.SET_PRINT_STYLEA(0, 'FrameColor', element.borderColor)
        }

        // 设置边框宽度
        if (element.borderWidth) {
            LODOP.SET_PRINT_STYLEA(0, 'FrameWidth', element.borderWidth)
        }
    }

    // 设置内边距
    if (element.paddingLeft) {
        LODOP.SET_PRINT_STYLEA(0, 'TextLeftSpacing', element.paddingLeft)
    }
    if (element.paddingTop) {
        LODOP.SET_PRINT_STYLEA(0, 'TextTopSpacing', element.paddingTop)
    }
    if (element.paddingRight) {
        LODOP.SET_PRINT_STYLEA(0, 'TextRightSpacing', element.paddingRight)
    }
    if (element.paddingBottom) {
        LODOP.SET_PRINT_STYLEA(0, 'TextBottomSpacing', element.paddingBottom)
    }
}

// 添加条码元素
function addBarcodeElement (action, LODOP, element, printData = {}) {
    let content = ''
    if (ACTIONS.PRINT === action) {
        if (element.fieldName) {
            content = printData[element.fieldName] != null ? String(printData[element.fieldName]) : ''
        } else {
            content = element.content || ''
        }
    } else {
        content = element.content || ''
    }

    LODOP.ADD_PRINT_BARCODE(toMmUnit(element.y), toMmUnit(element.x), toMmUnit(element.width), toMmUnit(element.height), element.barcodeType, content)

    // 添加条码处理
    if (element.barcodeType === 'QRCode') {
        // 设置二维码版本
        if (element.qrcodeVersion !== '0') {
            LODOP.SET_PRINT_STYLEA(0, 'QRCodeVersion', parseInt(element.qrcodeVersion))
        }
        // 设置二维码容错等级
        LODOP.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', element.qrcodeErrorLevel || 'L')
        // 设置二维码对齐方式
        LODOP.SET_PRINT_STYLEA(0, 'AlignJustify', 2)
    } else {
        const widthMm = toMmNum(element.width)
        const heightMm = toMmNum(element.height)
        // 设置条码线条宽度（单位：mm）
        const barcodeWidth = Math.max(0.2, widthMm / 50)
        LODOP.SET_PRINT_STYLEA(0, 'BarWidth', toMmUnit(barcodeWidth))

        // 设置条码高度和字体大小
        const fontSize = Math.max(2, heightMm / 8)
        const barcodeHeight = heightMm - (element.showText ? fontSize * 2 : 0)
        LODOP.SET_PRINT_STYLEA(0, 'BarHeight', toMmUnit(barcodeHeight))

        if (element.showText) {
            LODOP.SET_PRINT_STYLEA(0, 'ShowBarText', 1)
            LODOP.SET_PRINT_STYLEA(0, 'FontSize', fontSize)
        } else {
            LODOP.SET_PRINT_STYLEA(0, 'ShowBarText', 0)
        }

        // 设置文本对齐和字体
        LODOP.SET_PRINT_STYLEA(0, 'TextAlign', 'Center')
        //     LODOP.SET_PRINT_STYLEA(0, 'FontName', 'Microsoft YaHei')
    }

    // 设置旋转角度
    if (element.rotate) {
        LODOP.SET_PRINT_STYLEA(0, 'Angle', parseInt(element.rotate))
    }
}

/**
 * 解析文本内容，与 webLabelDesigner TextElement.displayText 保持一致
 * @param action
 * @param element
 * @param printData
 * @returns {string}
 */
function resolveTextContent (action, element, printData = {}) {
    if (ACTIONS.PRINT === action) {
        // 静态标签（无 fieldName）打印 title，如「RID：」「供应商：」
        if (element.showTitle && element.title && !element.fieldName) {
            return element.title
        }
        if (element.fieldName) {
            const val = printData[element.fieldName]
            return val != null && val !== '' ? String(val) : ''
        }
        return element.content || ''
    }
    if (element.showTitle && element.title) {
        if (element.fieldName && element.content) {
            return element.title + ':' + element.content
        }
        return element.title
    }
    return element.content || ''
}

/**
 * 绘制表格边框线
 * @param LODOP
 * @param x1
 * @param y1
 * @param x2
 * @param y2
 * @param lineStyle
 * @param lineWidth
 * @param color
 */
function addTableBorderLine (LODOP, x1, y1, x2, y2, lineStyle, lineWidth, color) {
    LODOP.ADD_PRINT_LINE(
        toMmUnit(y1), toMmUnit(x1),
        toMmUnit(y2), toMmUnit(x2),
        lineStyle || 0, toMmNum(lineWidth, 0.1)
    )
    LODOP.SET_PRINT_STYLEA(0, 'FontColor', color || '#000000')
}

/**
 * 按合并单元格绘制表格边框（LODOP 原生线条，兼容合并）
 * @param LODOP
 * @param element
 */
function addTableBorders (LODOP, element) {
    const rows = element.rows || 2
    const cols = element.cols || 2
    const cellMap = buildCellMap(element)
    const borderWidth = toMmNum(element.borderWidth, 0.1)
    const borderColor = element.borderColor || element.lineColor || '#000000'
    const lineStyle = element.borderStyle || 0

    for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
            const cellKey = `${row}-${col}`
            const cellInfo = cellMap[cellKey]
            if (cellInfo && cellInfo.isMerged) {
                continue
            }

            const cellPos = getCellPosition(element, row, col, cellMap)
            const x = toMmNum(element.x) + cellPos.x
            const y = toMmNum(element.y) + cellPos.y
            const w = cellPos.width
            const h = cellPos.height

            addTableBorderLine(LODOP, x, y, x + w, y, lineStyle, borderWidth, borderColor)
            addTableBorderLine(LODOP, x, y + h, x + w, y + h, lineStyle, borderWidth, borderColor)
            addTableBorderLine(LODOP, x, y, x, y + h, lineStyle, borderWidth, borderColor)
            addTableBorderLine(LODOP, x + w, y, x + w, y + h, lineStyle, borderWidth, borderColor)
        }
    }
}

/**
 * 计算单元格内内容的打印区域（使用单元格剩余宽高，避免 5mm 固定高度导致文字溢出到下一行）
 * @param content
 * @param cellPos
 * @param tableX
 * @param tableY
 * @param useFullCell 文本 true 占满单元格；条码 false 保留设计尺寸
 * @returns {{x: number, y: number, width: number, height: number}}
 */
function getCellContentPrintRect (content, cellPos, tableX, tableY, useFullCell = true) {
    const offsetX = toMmNum(content.x)
    const offsetY = toMmNum(content.y)
    const maxWidth = Math.max(1, cellPos.width - offsetX)
    const maxHeight = Math.max(1, cellPos.height - offsetY)
    const designWidth = toMmNum(content.width, maxWidth)
    const designHeight = toMmNum(content.height, maxHeight)
    return {
        x: toMmNum(tableX) + cellPos.x + offsetX,
        y: toMmNum(tableY) + cellPos.y + offsetY,
        width: useFullCell ? maxWidth : Math.min(designWidth, maxWidth),
        height: useFullCell ? maxHeight : Math.min(designHeight, maxHeight)
    }
}

/**
 * 绘制表格单元格内文本
 * @param action
 * @param LODOP
 * @param element
 * @param printData
 */
function addTableTexts (action, LODOP, element, printData = {}) {
    const rows = element.rows || 2
    const cols = element.cols || 2
    const cellMap = buildCellMap(element)

    for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
            const cellKey = `${row}-${col}`
            const cellInfo = cellMap[cellKey]
            if (cellInfo && cellInfo.isMerged) {
                continue
            }

            const cellPos = getCellPosition(element, row, col, cellMap)
            const contents = (element.cellContents && element.cellContents[cellKey]) || []

            contents.forEach(content => {
                if (content.type !== 'text') {
                    return
                }
                const rect = getCellContentPrintRect(content, cellPos, element.x, element.y)
                addTextElement(action, LODOP, {
                    ...content,
                    isCellContent: true,
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                }, printData)
            })
        }
    }
}

/**
 * 表格内条码使用 LODOP 原生控件叠加（HTML 模式无法渲染条码）
 * @param action
 * @param LODOP
 * @param element
 * @param printData
 */
function addTableBarcodes (action, LODOP, element, printData = {}) {
    const rows = element.rows || 2
    const cols = element.cols || 2
    const cellMap = buildCellMap(element)

    for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
            const cellKey = `${row}-${col}`
            const cellInfo = cellMap[cellKey]
            if (cellInfo && cellInfo.isMerged) {
                continue
            }

            const cellPos = getCellPosition(element, row, col, cellMap)
            const contents = (element.cellContents && element.cellContents[cellKey]) || []

            contents.forEach(content => {
                if (content.type !== 'barcode') {
                    return
                }
                const rect = getCellContentPrintRect(content, cellPos, element.x, element.y, false)
                addBarcodeElement(action, LODOP, {
                    ...content,
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                }, printData)
            })
        }
    }
}

/**
 * 构建表格单元格映射（含合并单元格信息）
 * @param tableElement
 * @returns {Object}
 */
function buildCellMap (tableElement) {
    const rows = tableElement.rows || 2
    const cols = tableElement.cols || 2
    const cellMap = {}

    for (let i = 0; i < rows; i++) {
        for (let j = 0; j < cols; j++) {
            cellMap[`${i}-${j}`] = { row: i, col: j, rowspan: 1, colspan: 1, isMerged: false }
        }
    }

    const cells = tableElement.cells || []
    const sortedCells = [...cells].sort((a, b) => {
        if (a.row !== b.row) {
            return a.row - b.row
        }
        return a.col - b.col
    })
    sortedCells.forEach(cell => {
        const key = `${cell.row}-${cell.col}`
        if (!cellMap[key]) {
            return
        }
        const rowspan = cell.rowspan || 1
        const colspan = cell.colspan || 1
        if (cell.row + rowspan > rows || cell.col + colspan > cols) {
            return
        }

        cellMap[key].rowspan = rowspan
        cellMap[key].colspan = colspan

        for (let r = cell.row; r < cell.row + rowspan; r++) {
            for (let c = cell.col; c < cell.col + colspan; c++) {
                if (r === cell.row && c === cell.col) {
                    continue
                }
                const mergedKey = `${r}-${c}`
                if (cellMap[mergedKey]) {
                    cellMap[mergedKey].isMerged = true
                    cellMap[mergedKey].mergedFrom = key
                }
            }
        }
    })
    return cellMap
}

/**
 * 计算单元格在表格内的相对位置与尺寸（单位：mm）
 * @param tableElement
 * @param row
 * @param col
 * @param cellMap
 * @returns {{x: number, y: number, width: number, height: number}}
 */
function getCellPosition (tableElement, row, col, cellMap) {
    const rows = tableElement.rows || 2
    const cols = tableElement.cols || 2
    const rowHeights = tableElement.rowHeights || new Array(rows).fill(100 / rows)
    const colWidths = tableElement.colWidths || new Array(cols).fill(100 / cols)

    const cellKey = `${row}-${col}`
    const cellInfo = cellMap[cellKey]

    let mainRow = row
    let mainCol = col
    let rowspan = 1
    let colspan = 1

    if (cellInfo) {
        if (cellInfo.isMerged && cellInfo.mergedFrom) {
            const mainKey = cellInfo.mergedFrom
            const [mainRowStr, mainColStr] = mainKey.split('-')
            mainRow = parseInt(mainRowStr)
            mainCol = parseInt(mainColStr)
            const mainCellInfo = cellMap[mainKey]
            rowspan = mainCellInfo ? mainCellInfo.rowspan : 1
            colspan = mainCellInfo ? mainCellInfo.colspan : 1
        } else {
            rowspan = cellInfo.rowspan || 1
            colspan = cellInfo.colspan || 1
        }
    }

    let cellTop = 0
    for (let i = 0; i < mainRow; i++) {
        cellTop += toMmNum(rowHeights[i], 100 / rows)
    }

    let cellLeft = 0
    for (let j = 0; j < mainCol; j++) {
        cellLeft += toMmNum(colWidths[j], 100 / cols)
    }

    let cellWidthPercent = 0
    for (let c = mainCol; c < mainCol + colspan; c++) {
        cellWidthPercent += toMmNum(colWidths[c], 100 / cols)
    }

    let cellHeightPercent = 0
    for (let r = mainRow; r < mainRow + rowspan; r++) {
        cellHeightPercent += toMmNum(rowHeights[r], 100 / rows)
    }

    const tableWidth = toMmNum(tableElement.width)
    const tableHeight = toMmNum(tableElement.height)

    return {
        x: (cellLeft / 100) * tableWidth,
        y: (cellTop / 100) * tableHeight,
        width: (cellWidthPercent / 100) * tableWidth,
        height: (cellHeightPercent / 100) * tableHeight
    }
}

/**
 * 添加表格元素（含单元格内文本/条码）
 * @param action
 * @param LODOP
 * @param element
 * @param printData
 */
function addTableElement (action, LODOP, element, printData = {}) {
    // LODOP 的 ADD_PRINT_HTM 不渲染 CSS 边框，改用原生线条 + 文本
    addTableBorders(LODOP, element)
    addTableTexts(action, LODOP, element, printData)
    addTableBarcodes(action, LODOP, element, printData)
}

// 添加线条元素
function addLineElement (LODOP, element) {
    // 添加直线到打印页面
    LODOP.ADD_PRINT_LINE(toMmUnit(element.y), toMmUnit(element.x), toMmUnit(element.endY), toMmUnit(element.endX), element.lineStyle || 0, toMmNum(element.lineWidth, 1))

    // 设置线条颜色
    LODOP.SET_PRINT_STYLEA(0, 'FontColor', element.lineColor || '#000000')
}

// 修改添加矩形元素方法
export function addRectElement (LODOP, element) {
    LODOP.ADD_PRINT_RECT(toMmUnit(element.y), toMmUnit(element.x), toMmUnit(element.width), toMmUnit(element.height), element.lineStyle || 0, toMmNum(element.lineWidth, 1))

    // 设置线条颜色
    LODOP.SET_PRINT_STYLEA(0, 'FontColor', element.lineColor || '#000000')
}

// 修改添加椭圆元素方法
export function addOvalElement (LODOP, element) {
    LODOP.ADD_PRINT_ELLIPSE(toMmUnit(element.y), toMmUnit(element.x), toMmUnit(element.height), toMmUnit(element.width), element.lineStyle || 0, toMmNum(element.lineWidth, 1))

    // 设置线条颜色
    LODOP.SET_PRINT_STYLEA(0, 'FontColor', element.lineColor || '#000000')
}

// 修改图片元素添加方法
export function addImageElement (LODOP, element) {
    if (element.imageUrl) {
        // 添加图片到打印页面
        LODOP.ADD_PRINT_IMAGE(toMmUnit(element.y), toMmUnit(element.x), toMmUnit(element.width), toMmUnit(element.height), element.imageUrl)

        // 设置图片样式
        LODOP.SET_PRINT_STYLEA(0, 'Stretch', element.imageMode === 'contain' ? 1 : 2)

        // 设置图片质量
        LODOP.SET_PRINT_STYLEA(0, 'TransColor', '#FFFFFF') // 设置透明色
        LODOP.SET_PRINT_STYLEA(0, 'Resolution', 600) // 设置分辨率

        // 如果有旋转角度，设置旋转
        if (element.rotate) {
            LODOP.SET_PRINT_STYLEA(0, 'Angle', parseInt(element.rotate))
        }
    }
}

// 添加像素到毫米的转换方法
export function pxToMm (px) {
    return px * 25.4 / 96
}

// 添加毫米到像素的转换方法
export function mmToPx (mm) {
    return Math.round(mm * 96 / 25.4)
}



// WEBPACK FOOTER //
// ./src/const/lodopPrint.js